import { Box, Button, IconButton, Paper, Tooltip, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import React, { useEffect, useMemo, useRef } from 'react'

import thankYouImg from '../../../assets/thank-you-exam-completion.svg'
import { Icons } from '../../../utils/utilities'
import { useLocation } from 'react-router-dom'

const copyContactNumber = () => {
    navigator.clipboard.writeText( `+998553010009` )
        .then( () => {
            console.log( "Text copied to clipboard successfully!" )
        } )
        .catch( err => {
            console.error( "Failed to copy text: ", err )
        } )
}

export default function AlreadyQualified ( { applicationNumber, programId } ) {

    const { pathname } = useLocation()
    const { palette, border } = useTheme()
    const { t } = useTranslation()

    const AVAILABLE_PROGRAMS = [
        { label: t( "program.btech" ), value: 1 },
        { label: t( "program.bca" ), value: 5 },
        { label: t( "program.bba" ), value: 7 }
    ]

    const downloadContractBtnRef = useRef()

    const thankyouPage = useMemo( () => pathname.match( /(thankyou)\/?$/ ), [pathname] )

    const program = AVAILABLE_PROGRAMS.find( program => program.value === +programId )

    const navigateToContractDownloadPage = () => {

        if ( applicationNumber && applicationNumber.match( /^AU\/\d\d\/\d{3,}$/ ) ) {
            window.open( `https://acharyaerp.uz/qualified-contract/${applicationNumber?.replace( /\//g, "-" )}` )
        }
    }

    useEffect( () => {
        const timeout = setTimeout( () => {
            downloadContractBtnRef.current.focus()
        }, 50 )

        return () => clearTimeout( timeout )
    }, [] )


    return (
        <Box component={Paper} sx={{ flexShrink: 0, borderRadius: "10px", padding: "20px", maxWidth: "510px" }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "20px", alignItems: "center" }} >

                <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "center" }} >
                    <Box component="img" src={thankYouImg} width="150px" alt="Attempt already qualified" />
                    <Typography variant='h6' lineHeight={1.2} textAlign="center" sx={{ fontSize: "1.6rem" }}>{thankyouPage ? t( 'thankYou.passed' ) : t( 'candidateLogin.examQualified' )}</Typography>
                    <Typography variant='subtitle2' textAlign="center" color='textSecondary' sx={{ fontSize: "0.875rem" }}>{t( 'candidateLogin.examQualifiedSubtext' )}</Typography>
                </Box>

                {program && <Typography color='textSecondary' sx={{ p: 1, borderRadius: 2, border: border[1], bgcolor: palette.contentBg }} variant='subtitle2' textAlign="center" >{t( 'label.selectedProgram' )} {program.label}</Typography>}

                <Box>
                    <Button
                        startIcon={Icons.default.DescriptionIconOutlined}
                        onClick={navigateToContractDownloadPage}
                        endIcon={Icons.default.DownloadIcon}
                        ref={downloadContractBtnRef}
                        sx={{
                            textTransform: "capitalize",
                            borderRadius: 5,
                            py: 1,
                            px: 2,
                            ":focus, :focus-visible": {
                                outline: `3px solid ${palette.primary.main}`,
                                outlineOffset: "2px"
                            },
                            animation: "scale-outline 3s ease infinite"
                        }}
                        variant='contained'
                        type='button'
                        size='small'
                        autoFocus
                    >
                        {t( 'button.downloadContract' )}
                    </Button>
                </Box>

                <Box borderRadius="10px" overflow="clip" border={`2px solid ${palette.primary.main}`}>
                    <Box padding="10px" display="flex" alignItems="flex-start" gap="10px">
                        <Typography variant='subtitle2' color='primary' sx={{ fontSize: "1.2rem" }}>{Icons.default.Info}</Typography>
                        <Typography variant='subtitle2' color='primary' sx={{ fontSize: "0.875rem" }}>{t( 'candidateLogin.contactAdmissionCounsellor' )}</Typography>
                    </Box>
                    <Box sx={{ display: "flex", gap: "10px", alignItems: "center", bgcolor: palette.primary.light + "22", padding: "10px", }}>
                        <Typography variant='subtitle2' flexGrow={1} >{t( 'candidateLogin.contactUs' )}  <Typography component="a" sx={{ fontStyle: "italic", fontSize: "inherit", color: "inherit", textDecoration: "underline" }} className='default-link' href={`tel:+998553010009`} >+998 553010009</Typography></Typography>
                        <Tooltip title={t( 'candidateLogin.contactTooltip' )}>
                            <IconButton onClick={() => copyContactNumber()} sx={{}} size='small'>
                                {Icons.default.CopyAll}
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>


            </Box>

        </Box>
    )
}
